import { v4 } from "uuid";

const generateUserAlias = () => {
    return `HoloUser_${v4().substring(0, 4)}`;
}

export default generateUserAlias;